import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useSanitize() {
  return {
    sanitize: GlobalPrototypes.sanitize,
  }
}
